import { useCommunityJoinSearchParams } from '@/src/features/community/ui/hooks/useCommunityJoinSearchParams'
import { CommunityJoinNextScreen } from '@/src/features/community/ui/screens/CommunityJoinNextScreen'

const CommunityJoinNextRouterPage = () => {
  const { idSlug, source } = useCommunityJoinSearchParams()

  if (!idSlug) return null

  return <CommunityJoinNextScreen idSlug={idSlug} source={source} />
}

export default CommunityJoinNextRouterPage
